// extracted by mini-css-extract-plugin
export var h2_semi_bold_serp = "j_P";
export var noBoxShadow = "j_R";
export var serpCard = "j_M";
export var serpCardContainer = "j_L";
export var serpDescription = "j_Q";
export var serpLink = "j_N";